// extracted by mini-css-extract-plugin
export var contact_float = "index-module--contact_float--i6boM";
export var contact_float_icon = "index-module--contact_float_icon--3aRF1";
export var contact_float_split = "index-module--contact_float_split--3zN9p";
export var contact_form_body = "index-module--contact_form_body--5Lan6";
export var contact_form_widget = "index-module--contact_form_widget--S9Ycs";
export var contact_modal = "index-module--contact_modal--bG+sh";
export var contact_modal_actions = "index-module--contact_modal_actions--CdLBj";
export var contact_modal_phone = "index-module--contact_modal_phone--34vg6";
export var contact_modal_title = "index-module--contact_modal_title--e8Qyp";
export var download = "index-module--download--Yiyhg";
export var download_list = "index-module--download_list--LTu0S";
export var download_list_item = "index-module--download_list_item--WiP7M";
export var download_title = "index-module--download_title--DR3Ng";
export var first_row = "index-module--first_row--rVQQD";
export var first_row_end = "index-module--first_row_end--rMZpK";
export var first_row_start = "index-module--first_row_start--than9";
export var header_phone = "index-module--header_phone--m-fKe";
export var header_phone_icon = "index-module--header_phone_icon--N80rg";
export var header_phone_label = "index-module--header_phone_label--FkIzm";